import React from "react";
import { IAccount } from "../Interfaces/IAccount";
import { ICustomeGroup } from "../Interfaces/ICustomeGroup";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { GroupChip } from "./GroupChip";
import { Add } from "@mui/icons-material";
import {checkPermission} from "../utils/permission";


interface IProps {
    account: IAccount;
    setAccount: React.Dispatch<React.SetStateAction<IAccount>>;
    groupArray: ICustomeGroup[];
}


export const AccountGroupView:React.FC<IProps> = ({account, setAccount, groupArray}) => {
    const groups = account.customGroups;
    const setGroups = (newGroups:number[]) => {
        setAccount((prev) => ({
            ...prev,
            customGroups: newGroups
        }))
    }

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleAddGroup = (idGroup:number) => {
        setGroups([
            ...groups,
            idGroup
        ])
        setAnchorEl(null);
    };

    const onDelete = (idGroup:number) => {
        setGroups([
            ...groups.filter(x => x !== idGroup)
        ])
    }


    return(
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                position: 'relative',
                minHeight: 44,
            }}
        >
            {(groups.length === 0) && <Box mt={2} width="100%" />}
            {groups.map(group => 
                <GroupChip
                    key={`idGroup-${group}`}
                    idGroup={group}
                    groupArray={groupArray}
                    size="medium"
                    onDelete={checkPermission(1,2) ? onDelete : undefined}
                />
            )}
            {checkPermission(1,2) &&
                <Box>
                    <IconButton 
                        title="Gruppenzugehörigkeit hinzufügen"
                        sx={{
                            ml: 0.5,
                            bgcolor: 'background.paper',
                            border: '1px solid',
                            borderColor: 'divider',
                            transition: 'transform 200ms ease, box-shadow 200ms ease',
                            '&:hover': {
                                transform: 'translateY(-1px)',
                                boxShadow: '0px 8px 16px rgba(15, 23, 42, 0.12)',
                            },
                        }}
                        onClick={handleOpenMenu}
                    >
                        <Add/>
                    </IconButton>
                    <Menu
                        id="basic-menu-groups"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={() => setAnchorEl(null)}
                    >
                        {groupArray.map(group => 
                            <MenuItem
                                onClick={() => handleAddGroup(group.id)}
                                disabled={groups.indexOf(group.id) !== -1}
                                key={`group-item-${group.id}`}
                            >
                                {group.customGroup}
                            </MenuItem>
                        )}
                    </Menu>
                </Box>
            }
        </Box>
    )
}
